import firebase from "firebase";
import "firebase/firestore";

const FIREBASE_CONFIG = {
  apiKey: "AIzaSyA8x2qyq6oiNM1fNP8oYxIoga34IG8dQKE",
  authDomain: "terrafuse-20754.firebaseapp.com",
  projectId: "terrafuse-20754",
  storageBucket: "terrafuse-20754.appspot.com",
  messagingSenderId: "368319961094",
  appId: "1:368319961094:web:6425cac0405c9e94234b87",
};

firebase.initializeApp(FIREBASE_CONFIG);

export default firebase;

export const firestore = firebase.firestore();
